import { render, staticRenderFns } from "./Franchisee.vue?vue&type=template&id=7ea0e142"
import script from "./Franchisee.vue?vue&type=script&lang=js"
export * from "./Franchisee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports